import { faQuestionSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button, DialogActions, DialogContent, Grid, Typography
} from '@mui/material';
import { TextField } from 'components/forms/inputs/InputField/InputField';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { translate } from 'utils';
import { FormHelper } from 'utils/helpers';
import { HeaderModal } from './_HeaderModal';

export const QuizLoginModal = ({ onClose, onConfirm }) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      traineeLastName: '',
      traineeFirstName: '',
      traineeEmail: ''
    }
  });

  const handleClose = useCallback(() => onClose(), [onClose]);

  const onSubmit = useCallback((data) => {
    onConfirm(data);
    onClose();
  }, [onConfirm, onClose]);

  return (
    <form
          autoComplete="off"
          name="traineeAuthenticationFormModal"
          style={{ maxWidth: 500 }}
          onSubmit={handleSubmit(onSubmit)}
      >
      <HeaderModal onClose={onClose}>
        <FontAwesomeIcon icon={faQuestionSquare} />
        <Typography component="span">
          {translate('common.identification')}
        </Typography>
      </HeaderModal>

      <DialogContent style={{ position: 'relative', overflow: 'hidden', paddingTop: '10px' }}>
        <Grid container direction="column" justifyContent="flex-start" spacing={2}>
          <Grid item>
            <Typography>{translate('quiz.loginBeforeStart')}</Typography>
          </Grid>
          <Grid item>
            <Controller
                  control={control}
                  name="traineeLastName"
                  render={({ field }) => (
                    <TextField
                          {...field}
                          error={!!errors.traineeLastName}
                          label={translate('common.lastName')}
                          placeholder={translate('common.enterYourLastName')}
                          required
                      />
                  )}
                  rules={{ required: true }}
              />
          </Grid>
          <Grid item>
            <Controller
                  control={control}
                  name="traineeFirstName"
                  render={({ field }) => (
                    <TextField
                          {...field}
                          error={!!errors.traineeFirstName}
                          label={translate('common.firstName')}
                          placeholder={translate('common.enterYourFirstName')}
                          required
                      />
                  )}
                  rules={{ required: true }}
              />
          </Grid>
          <Grid item>
            <Controller
                  control={control}
                  name="traineeEmail"
                  render={({ field }) => (
                    <TextField
                          {...field}
                          error={!!errors.traineeEmail}
                          label={translate('common.email')}
                          placeholder={translate('common.enterYourEmail')}
                          required
                      />
                  )}
                  rules={{
                    required: true,
                    validate: value => FormHelper.validateEmail(value)
                  }}
              />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>
          {translate('button.cancel')}
        </Button>
        <Button
              color="primary"
              type="submit"
          >
          {translate('button.begin')}
        </Button>
      </DialogActions>
    </form>
  );
};

QuizLoginModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  defaultValues: PropTypes.shape({})
};

QuizLoginModal.defaultProps = {
  defaultValues: {}
};
